import { render } from "./BookmarkPanel.vue?vue&type=template&id=78c3eace&scoped=true"
import script from "./BookmarkPanel.vue?vue&type=script&lang=js"
export * from "./BookmarkPanel.vue?vue&type=script&lang=js"

import "./BookmarkPanel.vue?vue&type=style&index=0&id=78c3eace&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c3eace"]])

export default __exports__